import { QUERY_PARAMS } from "@/data/constants";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PaymentStatusMixin extends Vue {
  // Life-cycle methods
  public created() {
    if (this.$_.has(this.$route.query, QUERY_PARAMS.PAYMENT_SUCCESS)) {
      this.$route.query[QUERY_PARAMS.PAYMENT_SUCCESS] === "true"
        ? this.onPaymentSuccess()
        : this.onPaymentFail();
      this.clearPaymentQueryParams();
    }
  }

  // Methods
  public onPaymentSuccess() {
    this.$buefy.snackbar.open({
      message: this.$t("_sentence.3d_payment_succeeds") as string,
      actionText: this.$t("_action.dismiss") as string,
      type: "is-success"
    });
  }

  public onPaymentFail() {
    this.$buefy.snackbar.open({
      message: this.$t("_sentence.3d_payment_failed") as string,
      actionText: this.$t("_action.dismiss") as string,
      type: "is-danger",
      indefinite: true
    });
  }

  public clearPaymentQueryParams() {
    const query = this.$_.clone(this.$route.query);
    const regex = new RegExp(
      `^(${[QUERY_PARAMS.PAYMENT_SUCCESS].join("|")})$`,
      "gm"
    );
    const matches = this.$_.keys(query)
      .join("\n")
      .match(regex);
    if (!matches || !matches.length) return;
    matches.forEach(key => delete query[key]);
    this.$router.replace({ query });
  }
}
